module.exports = __webpack_public_path__ + "static/media/TicTacToe.3dbccbff.jpg";